import { useField } from 'formik'
import { motion } from 'framer-motion'
import React from 'react'

const FormDropdown = ({ handle, name, options, required }) => {
  const [{ value }, { error, touched }, { setValue }] = useField(handle)
  const notEmpty = `${value}`.length > 0

  return (
    <div className="flex mb-8">
      <div className="w-full md:pr-4 md:w-1/2">
        <div className="relative flex">
          <motion.label
            className="absolute z-0 inline-flex px-1 pointer-events-none left-2.5 top-[11px]"
            style={{
              fontSize: notEmpty ? 10 : 16,
              backgroundColor: notEmpty ? '#F5F5F5' : 'transparent',
            }}
            animate={{
              y: notEmpty ? -18 : 0,
            }}
            transition={{ type: 'ease' }}
          >
            {name}
            {required ? '*' : ''}
          </motion.label>

          <select
            id={handle}
            name={handle}
            className={`w-full bg-transparent rounded ${
              error && touched ? 'border-red' : 'border-gray-5'
            } focus:outline-none focus:ring-1 focus:ring-black focus:border-black`}
            onChange={e => setValue(e.target.value)}
          >
            <option value="" aria-label="Please choose..."></option>
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}

export default FormDropdown
